import { Reveal } from "./Reveal";
import { EXPERIENCE } from "../data";

export default function Experience() {
  return (
    <section id="experience" data-testid="experience-section" className="relative py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <p className="font-display text-accent text-sm mb-3">Experience</p>
          <h2 className="font-display font-semibold text-3xl md:text-[2.6rem] leading-tight tracking-tight">
            Where I've made an impact
          </h2>
        </Reveal>

        <div className="mt-10 md:mt-14 space-y-6 md:space-y-8">
          {EXPERIENCE.map((e, i) => (
            <Reveal key={e.company} delay={i * 0.06}>
              <div className="card p-8 md:p-10 grid md:grid-cols-[0.9fr_2fr] gap-6 md:gap-12">
                <div>
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-2xl bg-white border border-ink/10 flex items-center justify-center p-2.5 shrink-0">
                      <img data-testid={`exp-logo-${i}`} src={e.logo} alt={`${e.company} logo`} className="w-full h-full object-contain" />
                    </div>
                    <div>
                      <h3 className="font-display font-semibold text-2xl md:text-[1.75rem] leading-tight">{e.company}</h3>
                      <p className="text-ink-soft mt-0.5">{e.role}</p>
                    </div>
                  </div>
                  <span className="tag mt-5 inline-block">{e.period}</span>
                </div>
                <ul className="space-y-4">
                  {e.points.map((p, j) => (
                    <li key={j} className="flex gap-4 leading-relaxed">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" />
                      <span className="text-ink/85">{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
